// extracted by mini-css-extract-plugin
export default {"card":"Card_card__fzgN8","statistic":"Card_statistic__DlgGw"};